<template>
  <b-nav-item-dropdown right v-track-click id="header-user-dropdown">
    <template slot="button-content">
      <img
        :src="require(`@/assets/images/header/lang/${currentLocale}.svg`)"
        width="18"
        height="18"
      />
    </template>
    <b-dropdown-item
      v-for="i in Object.keys(lang)"
      :key="i"
      @click.prevent="changeLocale(i)"
      v-track-click
      :class="{ active: currentLocale === i }"
    >
      <img
        :src="require(`@/assets/images/header/lang/${i}.svg`)"
        width="18"
        height="18"
      />
      {{ lang[i] }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<style lang="scss" scoped>
img {
  vertical-align: text-bottom;
}
</style>
<script>
export default {
  data() {
    return {
      currentLocale: this.$store.state.account.currentLocale,
      lang: {
        'es-MX': 'Español',
        'en-MX': 'English'
      },
      validatorLang: {
        'en-IN': 'en',
        'en-MX': 'en',
        'es-MX': 'es'
      }
    }
  },
  methods: {
    changeLocale(locale) {
      this.currentLocale = locale
      this.$i18n.locale = locale
      this.$store.dispatch('setLocale', locale)
      this.$validator.localize(this.validatorLang[`${locale}`])
    }
  }
}
</script>
